module.exports = __webpack_public_path__ + "static/media/color_bg.ac036daa.jpg";